const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const looksLikeEmail = (value) => EMAIL_RE.test(String(value || "").trim());
const nameParts = (value) => String(value || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
export const getGuardianDisplayNameIssue = (value, userEmail) => {
    const name = String(value || "").trim();
    if (!name) {
        return "Debes indicar tu nombre para continuar.";
    }
    if (looksLikeEmail(name)) {
        return "Tu nombre no puede ser un correo electrónico. Indica nombre y apellido.";
    }
    if (userEmail &&
        name.toLowerCase() === String(userEmail).trim().toLowerCase()) {
        return "Tu nombre no puede ser igual a tu correo electrónico.";
    }
    const parts = nameParts(name);
    if (parts.length < 2) {
        return "Indica tu nombre y apellido (al menos dos palabras).";
    }
    if (parts.some((part) => part.length < 2)) {
        return "Cada parte del nombre debe tener al menos 2 caracteres.";
    }
    return null;
};
export const isGuardianDisplayNameValid = (value, userEmail) => !getGuardianDisplayNameIssue(value, userEmail);
